module.exports = __webpack_public_path__ + "static/media/BBC_ProjectReith_WorldNews_Tile_Red_RGB.126874c5.svg";